import React from "react";
import { Sun, Moon, Languages } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useI18n } from "@/lib/i18n";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button onClick={toggle} data-testid="theme-toggle"
      className="flex h-9 w-9 items-center justify-center rounded-md border border-border hover:border-primary hover:text-primary transition-colors"
      aria-label="Toggle theme">
      {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}

export function LanguageToggle() {
  const { lang, setLang } = useI18n();
  return (
    <button onClick={() => setLang(lang === "de" ? "en" : "de")} data-testid="language-toggle"
      className="flex h-9 items-center gap-1.5 rounded-md border border-border px-2.5 hover:border-primary hover:text-primary transition-colors text-sm font-semibold uppercase">
      <Languages size={16} /> {lang}
    </button>
  );
}
